var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "footer-container" }, [
    _c("div", { staticClass: "footer-content" }, [
      _c("img", {
        attrs: {
          src: require("@/common/assets/icons/drc-logo.svg"),
          alt: "drc-footer"
        }
      }),
      _c("ul", { staticClass: "footer-options" }, [
        _c(
          "li",
          {
            on: {
              click: function($event) {
                return _vm.redirectToResources()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("common.footer.resources")))]
        ),
        _c(
          "li",
          {
            attrs: { id: "report" },
            on: {
              click: function($event) {
                return _vm.handleReportDialogShow($event)
              }
            }
          },
          [
            _vm._v(" " + _vm._s(_vm.$t("common.footer.reportProblem")) + " "),
            _vm.showSendReportDialog
              ? _c("ReportAProblem", {
                  attrs: {
                    title: `${_vm.$t("projectPage.what")}`,
                    sending: _vm.sending
                  },
                  on: {
                    closeDialog: _vm.handleReportDialogClose,
                    handleMessage: _vm.sendEmailForProblem
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c("li", [
          _c("a", { attrs: { href: "mailto:pavlina.venkova@akkodis.com" } }, [
            _vm._v(_vm._s(_vm.$t("common.footer.contactCMT")))
          ])
        ])
      ]),
      _c("span", [_vm._v("© 2025 Akkodis. All rights reserved.")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }